import {Component, ViewChild} from "@angular/core";
import {ActivatedRoute, Router} from "@angular/router";
import {WorkflowService} from "../workflow.service";
import {WorkflowStep} from "../workflow-step";
import {DeploymentWorkflowService} from "./deployment-workflow.service";
import {WorkflowTargetInfoModel} from "../models/workflow-target-info.model";
import {SuccessComponent} from "../../errors/success.component";
import {WorkflowStepStatus} from "../models/workflow-step-status.enum";
import {DialogService} from "../../bootstrap-modal/dialog.service";
import {handleErrors} from "../../misc/handle-errors.decorator";
import {toggleLoading} from "../../misc/loading.decorator";

@Component({
  templateUrl: "./export-sms-config.template.pug",
  providers: [DeploymentWorkflowService],
})
export class ExportSmsConfigComponent extends WorkflowStep {
  disableStep: boolean = false;
  loading: boolean = true;
  projectId: string = "";
  deploymentId: string = "";
  error: Error;
  smsApiSuccess: string = "";
  disableSmsSend: boolean = false;

  @ViewChild(SuccessComponent) success: SuccessComponent;

  constructor(
    public route: ActivatedRoute,
    public router: Router,
    public workflowService: WorkflowService,
    public deploymentWorkflowService: DeploymentWorkflowService,
    public dialogService: DialogService,
  ) {
    super(true);
  }

  @toggleLoading()
  @handleErrors()
  async ready(workflowTargetInfo: WorkflowTargetInfoModel) {
    this.deploymentId = workflowTargetInfo.targetId;
    this.projectId = workflowTargetInfo.projectId;

    const {areThereSmsRulesToSend} = await await this.deploymentWorkflowService.isSendToSmsReady(
      this.deploymentId,
      this.projectId,
    );

    if (!areThereSmsRulesToSend) {
      await this.workflowService.setStepStatus(WorkflowStepStatus.Completed);
      this.smsApiSuccess = "No rules to export. You may continue.";
      this.disableSmsSend = true;
    }
  }

  @toggleLoading()
  @handleErrors()
  async sendToSms() {
    this.error = null;
    this.loading = true;

    const sendResult = await this.deploymentWorkflowService.sendSmsData(this.deploymentId, this.projectId);

    this.smsApiSuccess = "";

    if (sendResult.success) {
      await this.workflowService.setStepStatus(WorkflowStepStatus.Completed);
      this.smsApiSuccess = "Consumable data was sent to the supply management service";
    }
  }
}
